module.exports = __webpack_public_path__ + "static/11_oksana_strashna-682cfd2864ed5065fe5d2d53d6721b9f.jpg";